import React from 'react';
import { RepeatIcon, ReplaceIcon, BookOpenIcon } from 'lucide-react';
const mechanisms = [{
  icon: RepeatIcon,
  title: 'Repetición inteligente',
  description: 'Repasos cortos antes de olvidar.'
}, {
  icon: ReplaceIcon,
  title: 'Sustitución',
  description: 'Aprendes estructuras y cambias 1 parte para crear 50 frases sin pensar.'
}, {
  icon: BookOpenIcon,
  title: 'Contexto',
  description: 'Historias + situaciones reales para que el inglés "se pegue".'
}];
export function UniqueMechanism() {
  return <section className="w-full bg-white py-8 md:py-14 px-4" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-3" data-id="element-167">
          Este pack funciona por un mecanismo simple:
        </h2>

        <p className="text-xl md:text-2xl font-bold text-[#FF6B00] text-center mb-6" data-id="element-168">
          REPETICIÓN INTELIGENTE + SUSTITUCIÓN + CONTEXTO
        </p>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-169">
          {mechanisms.map((mechanism, index) => <div key={index} className="bg-[#F8F9FA] p-6 rounded-xl text-center" data-id="element-170">
              <mechanism.icon className="w-12 h-12 text-[#FF6B00] mx-auto mb-4" data-id="element-171" />
              <h3 className="text-lg font-bold text-[#1A1A2E] mb-2" data-id="element-172">
                {mechanism.title}
              </h3>
              <p className="text-[#4A4A5A]" data-id="element-173">{mechanism.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}